import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    color: "#4c9c50",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M3.724 5.606H20.38v1.576H3.724zm-.005 3.83V8.394h16.667v1.042h1.667v7.813c0 .633-4.477 1.145-10 1.145s-10-.512-10-1.145V9.436z" fill="currentColor"/>' }
  })
);